module.exports = __webpack_public_path__ + "assets/img/NL.f4300625.svg";